import React from 'react';

import { QualificationStatus } from 'common/types';
import { Icon } from '@fuxi/eevee-ui';

import NotCertificationHomeSvg from 'common/assets/icon/not-certification-home.svg';
import CertificationHomeSvg from 'common/assets/icon/certification-home.svg';
import cx from './QualificationTag.module.css';

const QualificationLabelTextColor = {
  [QualificationStatus.Unverified]: 'var(--color-text-secondary)',
  [QualificationStatus.Waiting]: 'var(--color-text-secondary)',
  [QualificationStatus.Failed]: 'var(--color-text-secondary)',
  [QualificationStatus.Verified]: 'var(--color-primary-hover)',
};

const QualificationLabelText = {
  [QualificationStatus.Unverified]: '未认证创作者',
  [QualificationStatus.Waiting]: '未认证创作者',
  [QualificationStatus.Failed]: '未认证创作者',
  [QualificationStatus.Verified]: '认证创作者',
};

const QualificationLabelBgColor = {
  [QualificationStatus.Unverified]: 'var(--color-primary-bg)',
  [QualificationStatus.Waiting]: 'var(--color-primary-bg)',
  [QualificationStatus.Failed]: 'var(--color-primary-bg)',
  [QualificationStatus.Verified]: 'var(--color-primary-bg)',
};
const QualificationLabelIcon = {
  [QualificationStatus.Unverified]: <img src={NotCertificationHomeSvg} alt="" />,
  [QualificationStatus.Waiting]: <img src={NotCertificationHomeSvg} alt="" />,
  [QualificationStatus.Failed]: <img src={NotCertificationHomeSvg} alt="" />,
  [QualificationStatus.Verified]: <img src={CertificationHomeSvg} alt="" />,
};

const QualificationTag: React.FC<{
  mini?: boolean;
  status: QualificationStatus;
  onClick?: () => void;
  showRequirementType?: boolean;
  requirementTypeChildren?: React.ReactNode;
  hasNext?: boolean;
}> = ({ mini, onClick, status, showRequirementType, requirementTypeChildren, hasNext }) => {
  return (
    <div
      onClick={onClick}
      className={cx('artist-qualification-label', { mini })}
      style={{
        color: QualificationLabelTextColor[status!],
        backgroundColor: QualificationLabelBgColor[status!],
      }}>
      {QualificationLabelIcon[status!]}
      <div className="w-2px" />
      {QualificationLabelText[status!]}
      {showRequirementType && status === QualificationStatus.Verified && requirementTypeChildren}

      {hasNext && status !== QualificationStatus.Verified && <Icon name="Next" size={16} />}
    </div>
  );
};
export default QualificationTag;
